import _ from 'lodash'
import * as d3 from 'd3-selection'
import constants from 'scoreboard/components/constants'

var colorGroups = [
	[ 'turquoise-dark', 'turquoise-medium', 'turquoise-light', 'blue-dark', 'blue-medium', 'blue-light' ],
	[ 'periwinkle-dark', 'periwinkle-medium', 'periwinkle-light','purple-dark', 'purple-medium', 'purple-light' ],
	[ 'fuchsia-dark', 'fuchsia-medium', 'fuchsia-light', 'red-dark', 'red-medium', 'red-light' ],
	[ 'orange-dark', 'orange-medium', 'orange-light', 'yellow-dark', 'yellow-medium', 'yellow-light' ],
	[ 'green-dark', 'green-medium', 'green-light', 'gray-dark', 'gray-medium', 'gray-light' ]
]

function grouped () {
	return _.cloneDeep(colorGroups)
}

function prioritized () {
	// Order comes from Java enum ChartSeriesColor
	return _.clone(constants.seriesColors)
}

/**
 * Returns the next highest priority chart color after omitting ones that are
 * already used
 */
function nextPrioritized (used) {
	let unused = _.without(prioritized(), ...used)
	return unused.length === 0 ? prioritized()[0] : unused[0]
}

function toggleColor (el, newColor) {
	var icon = d3.select(el)

	_.each(constants.seriesColors, function (color) {
		icon.classed(color, color === newColor)
	})
}

export { grouped }
export { prioritized }
export { nextPrioritized }
export { toggleColor }
